import { render, staticRenderFns } from "./CommentInputBox.vue?vue&type=template&id=f286911a&scoped=true&"
import script from "./CommentInputBox.vue?vue&type=script&lang=js&"
export * from "./CommentInputBox.vue?vue&type=script&lang=js&"
import style0 from "./CommentInputBox.vue?vue&type=style&index=0&id=f286911a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f286911a",
  null
  
)

export default component.exports